import React from "react";
import { ArrowDownIcon, CheckIcon, XIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfterSection() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-75" data-mp="3fekba0fb6tnr">
      <div className="mx-auto max-w-6xl" data-id="element-76" data-mp="3ff2ejh0e2856">
        <SectionHeading title={<>Before vs. after the Blueprint™</>} data-id="element-77" data-mp="6yqrncpol22h" />

        <div className="relative mt-10 grid gap-4 md:grid-cols-2 md:gap-6" data-id="element-78" data-mp="6zimglbgevrp">
          <div className="rounded-3xl bg-alert-soft p-5 sm:p-8" data-id="element-79" data-mp="bwilwddst09u">
            <div className="flex items-center gap-3" data-id="element-80" data-mp="3tev1d18so47v">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-alert" data-id="element-81" data-mp="3te1tty20haoo">
                <XIcon className="h-6 w-6 text-white" strokeWidth={3} aria-hidden="true" data-id="element-82" data-mp="267cwcf9c0w3" />
              </span>
              <h3 className="text-2xl font-extrabold uppercase tracking-tight text-alert" data-id="element-83" data-mp="pvrzd5amdga4">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-84" data-mp="22nurfv9jsane">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-85" data-mp="1xp1crziiydln">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-86" data-mp="1xqukzj8sd5vr" />
                  <span className="text-base font-medium leading-snug text-ink" data-id="element-87" data-mp="2cg0hv0k5ik0h">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex justify-center md:hidden" aria-hidden="true" data-id="element-88" data-mp="2ldklgg5hkse9">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy" data-id="element-89" data-mp="2gg0viizfer6h">
              <ArrowDownIcon className="h-6 w-6 text-gold" strokeWidth={3} data-id="element-90" data-mp="2vci8tfr6efvo" />
            </span>
          </div>

          <div className="rounded-3xl bg-cta-soft p-5 ring-2 ring-cta sm:p-8" data-id="element-91" data-mp="2qdfbkhhftdy9">
            <div className="flex items-center gap-3" data-id="element-92" data-mp="10yh8eqfz9kth">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cta" data-id="element-93" data-mp="10zafxtmrgeco">
                <CheckIcon className="h-6 w-6 text-white" strokeWidth={3} aria-hidden="true" data-id="element-94" data-mp="w18puoqx3erp" />
              </span>
              <h3 className="text-2xl font-extrabold uppercase tracking-tight text-cta-dark" data-id="element-95" data-mp="1lpw913y1sbnf">After — with the Blueprint™</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-96" data-mp="1unyf3xwn1uhk">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-97" data-mp="1znb3wo72lbms">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-98" data-mp="1zlhskvlii38g" />
                  <span className="text-base font-semibold leading-snug text-ink" data-id="element-99" data-mp="24kupyaa0espa">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-xl font-bold leading-snug text-navy" data-id="element-100" data-mp="2dfr99vng1lqv">
          My goal is simple: help you spend less time searching for information and more time studying the concepts that matter.
        </p>

        <SectionCta label="I want a more structured approach" data-id="element-101" data-mp="2sc04mm47rey0" />
      </div>
    </section>;
}